export class QuestionAnswer {

    questionId: number;
	questionName: string;
	optionOne: string;
	optionTwo: string;
	optionThree: string;
	optionFour: string;
	answer: string;
	testType: number;
    constructor(){
    }
}
